var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("polygon", {
  points: "50,5 5,50 50,95 95,50",
  fill: "#012169"
});

var _ref3 = /*#__PURE__*/React.createElement("polygon", {
  points: "25,31 69,75 75,69 31,25",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("polygon", {
  points: "75,31 69,25 25,69 31,75",
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("polygon", {
  points: "25,27 73,75 75,73 27,25",
  fill: "#C8102E"
});

var _ref6 = /*#__PURE__*/React.createElement("polygon", {
  points: "25,73 73,25 75,27 27,75",
  fill: "#C8102E"
});

var _ref7 = /*#__PURE__*/React.createElement("polygon", {
  points: "42,13 42,42 13,42 13,58 42,58 42,87 58,87 58,58 87,58 87,42 58,42 58,13",
  fill: "white"
});

var _ref8 = /*#__PURE__*/React.createElement("polygon", {
  points: "44,6 44,44 6,44 6,56 44,56 44,94 56,94 56,56 94,56 94,44 56,44 56,6",
  fill: "#C8102E"
});

function SvgGb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGb);
export default __webpack_public_path__ + "static/media/gb.6f15d076a2f4d37b2d8879bb9fa565ec.svg";
export { ForwardRef as ReactComponent };